<template>
  <b-modal
    @close="closeDecisionModal()"
    hide-footer
    v-if="request.cerfa1402301"
    v-model="vModel"
    size="xl"
    :title="'Décision - Permission de voirie - Réseaux'"
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(decision)">
        <b-row>
          <b-col lg="5" md="3" sm="12" cols="12">
            <label class="control-label">
              Décision <span class="red">*</span> :
            </label>
          </b-col>
          <b-col lg="4" md="9" sm="12" cols="12">
            <ValidationProvider
              mode="lazy"
              v-slot="{ errors }"
              rules="required"
              name="décision"
            >
              <b-form-radio-group
                v-model="request.cerfa1402301.isFavorable"
                :options="optionsDecision"
              ></b-form-radio-group>
              <div class="error">{{ errors[0] }}</div>
            </ValidationProvider>
          </b-col>
        </b-row>
        <div v-if="request.cerfa1402301.isFavorable == false">
          <b-row>
            <b-col lg="3" md="3" sm="12" cols="12">
              <label class="control-label">Motifs :</label>
            </b-col>
            <b-col lg="9" md="9" sm="12" cols="12">
              <b-form-textarea
                v-model="request.cerfa1402301.commentDecision"
                id="commentDecision"
              ></b-form-textarea>
            </b-col>
          </b-row>
        </div>
        <div v-if="request.cerfa1402301.isFavorable == true">
          <b-row>
            <b-col lg="5" md="3" sm="12" cols="12">
              <label class="control-label">Annexe 1 (PDF):</label>
            </b-col>
            <b-col lg="6" md="9" sm="12" cols="12">
              <b-form-file
                browse-text="Ouvrir"
                v-model="annexe1.file"
                placeholder="Choisissez un fichier ou glissez le ici..."
                drop-placeholder="Glissez un Fichier ici..."
                accept="application/pdf"
              ></b-form-file>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="5" md="3" sm="12" cols="12">
              <label class="control-label">Annexe 2 (PDF):</label>
            </b-col>
            <b-col lg="6" md="9" sm="12" cols="12">
              <b-form-file
                browse-text="Ouvrir"
                v-model="annexe2.file"
                placeholder="Choisissez un fichier ou glissez le ici..."
                drop-placeholder="Glissez un Fichier ici..."
                accept="application/pdf"
              ></b-form-file>
            </b-col>
          </b-row>
          <!-- dropdown adresse principale -->
          <b-card no-body class="my-2">
            <b-card-header class="p-0">
              <b-button block v-b-toggle.adresse-principale>
                Adresse Principale
              </b-button>
            </b-card-header>
            <b-collapse
              id="adresse-principale"
              visible
              accordion="principale"
              role="tabpanel"
            >
              <b-card-body>
                <b-row>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Rejet EU:</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionRejetEU"
                      :options="optionsOuiNonRejetTravaux"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row v-if="request.cerfa1402301.decisionRejetEU == true">
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Surface(m²) :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-input
                      type="number"
                      step="0.01"
                      min="0.00"
                      size="lg"
                      @change="calcDebitLs(request.cerfa1402301)"
                      v-model="request.cerfa1402301.decisionSurfacem2"
                    ></b-form-input>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Débit (l/sec) :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-input
                      size="lg"
                      type="number"
                      step="0.01"
                      min="0.00"
                      max="1000.00"
                      placeholder="3"
                      @change="calcDebitLs(request.cerfa1402301)"
                      v-model="request.cerfa1402301.decisionDebitLS"
                    ></b-form-input>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Débit (l/s/ha) :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-input
                      size="lg"
                      type="number"
                      :disabled="true"
                      v-model="request.cerfa1402301.decisionResultCalc"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row v-if="request.cerfa1402301.decisionRejetEU == false">
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Sondage :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionSondage"
                      :options="optionsOuiNonSondage"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Tranchée chaussée :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-select
                      v-model="request.cerfa1402301.decisionRoadwayTrench"
                      :options="optionsChausee"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Tranchée trottoir :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-select
                      v-model="request.cerfa1402301.decisionSidewalkTrench"
                      :options="optionsTrottoir"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label"
                      >Tranchée accotement et terrain vierges :</label
                    >
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-select
                      v-model="
                        request.cerfa1402301.decisionShoulderVirginLandTrench
                      "
                      :options="optionsAccotement"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label"
                      >Signalisation horizontale :</label
                    >
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionHorizontalSignage"
                      :options="optionsOuiNonSignalH"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label"
                      >Information sur les aménagements :</label
                    >
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-checkbox-group
                      v-model="optionsAmenagements_selected"
                      :options="optionsAmenagements"
                    ></b-form-checkbox-group>
                  </b-col>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Fonçage :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionSinking"
                      :options="optionsFoncage"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col cols="12">
                    <b-row
                      v-if="request.cerfa1402301.decisionSinking == 'préconisé'"
                    >
                      <b-col lg="5" md="3" sm="12" cols="12">
                        <label class="control-label">Tranchée chaussée :</label>
                      </b-col>
                      <b-col lg="4" md="9" sm="12" cols="12">
                        <b-form-select
                          v-model="
                            request.cerfa1402301
                              .decisionRoadwayTrenchRecommended
                          "
                          :options="optionsChausee"
                        ></b-form-select>
                      </b-col>
                      <b-col lg="5" md="3" sm="12" cols="12">
                        <label class="control-label">Tranchée trottoir :</label>
                      </b-col>
                      <b-col lg="4" md="9" sm="12" cols="12">
                        <b-form-select
                          v-model="
                            request.cerfa1402301
                              .decisionSidewalkTrenchRecommended
                          "
                          :options="optionsTrottoir"
                        ></b-form-select>
                      </b-col>
                      <b-col lg="5" md="3" sm="12" cols="12">
                        <label class="control-label">
                          Tranchée accotement et terrain vierges :
                        </label>
                      </b-col>
                      <b-col lg="4" md="9" sm="12" cols="12">
                        <b-form-select
                          v-model="
                            request.cerfa1402301
                              .decisionShoulderVirginLandTrenchRecommended
                          "
                          :options="optionsAccotement"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Réfection :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-checkbox-group
                      v-model="decisionRefectionValues"
                      :options="optionsRefection"
                    ></b-form-checkbox-group>
                  </b-col>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Réseau de transport :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="request.cerfa1402301.decisionTransportNetwork"
                      :options="optionsOuiNonReseauTransport"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Aérien :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-checkbox-group
                      v-model="optionsAerien_selected"
                      :options="optionsAerien"
                    ></b-form-checkbox-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>

          <!-- TOUTES LES AUTRES ADRESSES -->
          <b-card
            no-body
            class="my-2"
            v-for="(address, index) in request.adresses"
            :key="index"
          >
            <b-card-header class="p-0">
              <b-button block v-b-toggle="'adresse-secondaire-' + index"
                >Adresse secondaire ({{ index + 1 }}) :
                <font-awesome-icon class="mr-1" icon="map-marker-alt" />{{
                  address.addressNum
                }}
                {{ address.addressType }} {{ address.addressName }},
                {{ address.addressPostalCode }}
                {{ address.addressCity }}</b-button
              >
            </b-card-header>
            <b-collapse
              :id="'adresse-secondaire-' + index"
              accordion="secondaire"
              role="tabpanel"
            >
              <b-card-body>
                <b-row>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Rejet EU:</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionRejetEU"
                      :options="optionsOuiNonRejetTravaux"
                    ></b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row v-if="address.prescriptions.decisionRejetEU == true">
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Surface(m²) :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-input
                      type="number"
                      step="0.01"
                      min="0.00"
                      size="lg"
                      @change="calcDebitLs(address.prescriptions)"
                      v-model="address.prescriptions.decisionSurfacem2"
                    ></b-form-input>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Débit (l/sec) :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-input
                      size="lg"
                      type="number"
                      step="0.01"
                      min="0.00"
                      max="1000.00"
                      placeholder="3"
                      @change="calcDebitLs(address.prescriptions)"
                      v-model="address.prescriptions.decisionDebitLS"
                    ></b-form-input>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Débit (l/s/ha) :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-input
                      size="lg"
                      type="number"
                      :disabled="true"
                      v-model="address.prescriptions.decisionResultCalc"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row v-if="address.prescriptions.decisionRejetEU == false">
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Sondage :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionSondage"
                      :options="optionsOuiNonSondage"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Tranchée chaussée :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-select
                      v-model="address.prescriptions.decisionRoadwayTrench"
                      :options="optionsChausee"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Tranchée trottoir :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-select
                      v-model="address.prescriptions.decisionSidewalkTrench"
                      :options="optionsTrottoir"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label"
                      >Tranchée accotement et terrain vierges :</label
                    >
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-select
                      v-model="
                        address.prescriptions.decisionShoulderVirginLandTrench
                      "
                      :options="optionsAccotement"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label"
                      >Signalisation horizontale :</label
                    >
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionHorizontalSignage"
                      :options="optionsOuiNonSignalH"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label"
                      >Information sur les aménagements :</label
                    >
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-checkbox-group
                      v-model="address.prescriptions.amenagements"
                      :options="optionsAmenagements"
                    ></b-form-checkbox-group>
                  </b-col>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Fonçage :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionSinking"
                      :options="optionsFoncage"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col cols="12">
                    <b-row
                      v-if="
                        address.prescriptions.decisionSinking == 'préconisé'
                      "
                    >
                      <b-col lg="5" md="3" sm="12" cols="12">
                        <label class="control-label">Tranchée chaussée :</label>
                      </b-col>
                      <b-col lg="4" md="9" sm="12" cols="12">
                        <b-form-select
                          v-model="
                            address.prescriptions
                              .decisionRoadwayTrenchRecommended
                          "
                          :options="optionsChausee"
                        ></b-form-select>
                      </b-col>
                      <b-col lg="5" md="3" sm="12" cols="12">
                        <label class="control-label">Tranchée trottoir :</label>
                      </b-col>
                      <b-col lg="4" md="9" sm="12" cols="12">
                        <b-form-select
                          v-model="
                            address.prescriptions
                              .decisionSidewalkTrenchRecommended
                          "
                          :options="optionsTrottoir"
                        ></b-form-select>
                      </b-col>
                      <b-col lg="5" md="3" sm="12" cols="12">
                        <label class="control-label"
                          >Tranchée accotement et terrain vierges :</label
                        >
                      </b-col>
                      <b-col lg="4" md="9" sm="12" cols="12">
                        <b-form-select
                          v-model="
                            address.prescriptions
                              .decisionShoulderVirginLandTrenchRecommended
                          "
                          :options="optionsAccotement"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col lg="3" md="3" sm="12" cols="12">
                    <label class="control-label">Réfection :</label>
                  </b-col>
                  <b-col lg="9" md="9" sm="12" cols="12">
                    <b-form-checkbox-group
                      v-model="address.prescriptions.reflection"
                      :options="optionsRefection"
                    ></b-form-checkbox-group>
                  </b-col>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Réseau de transport :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-radio-group
                      v-model="address.prescriptions.decisionTransportNetwork"
                      :options="optionsOuiNonReseauTransport"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col lg="5" md="3" sm="12" cols="12">
                    <label class="control-label">Aérien :</label>
                  </b-col>
                  <b-col lg="4" md="9" sm="12" cols="12">
                    <b-form-checkbox-group
                      v-model="address.prescriptions.aerien"
                      :options="optionsAerien"
                    ></b-form-checkbox-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <div v-for="(mail, index) in request.mailArreteSignes" :key="mail.id">
          <b-row>
            <b-col lg="4" md="6" sm="12" cols="12">
              <label
                ><b>{{ index + 1 }}</b
                >, Mail :</label
              >
              <ValidationProvider
                mode="lazy"
                v-slot="{ errors }"
                rules="required|email"
                name="email"
              >
                <b-form-input v-model="mail.mail"></b-form-input>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
            <b-col lg="4" md="6" sm="12" cols="12">
              <label>Dénomination:</label>
              <b-form-input v-model="mail.name"></b-form-input>
            </b-col>
            <b-col lg="1" md="6" sm="12" cols="12">
              <b-button
                class="center-icone"
                size="sm"
                variant="danger"
                style="margin-top: 40px"
                @click="removeDestinataire(index)"
                ><font-awesome-icon icon="times"></font-awesome-icon
              ></b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col lg="3" md="6" sm="12" cols="12" v-if="showBtnArreteEdition">
            <b-button
              class="mr-5 mb-2"
              variant="primary"
              size="sm"
              @click="doArrete()"
              :disabled="showBtnGen"
              >Générer l'arrêté
            </b-button>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="showBtnArreteEdition == false"
          >
            <b-button
              class="mr-5 mb-2"
              variant="primary"
              size="sm"
              @click="editArrete()"
              :disabled="showBtnArreteEdition"
              >Éditer l'arrêté
            </b-button>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="showBtnArreteEdition == false"
          >
            <b-button
              class="mr-5 mb-2"
              variant="danger"
              size="sm"
              @click="removeCourrier()"
              :disabled="showBtnArreteEdition"
              >Supprimer l'arrêté
            </b-button>
          </b-col>
          <b-col
            lg="3"
            md="6"
            sm="12"
            cols="12"
            v-if="
              !showBtnArreteEdition &&
                ((request.cerfa1402301 != null &&
                  request.individualAlignmentRequest == null) ||
                  (request.cerfa1402301 &&
                    request.cerfa1402301.isAccessDevelopment == false) ||
                  (request.individualAlignmentRequest != null &&
                    request.cerfa1402301 == null))
            "
          >
            <b-button
              type="submit"
              :disabled="showBtnArreteEdition"
              class="mr-5 mb-2"
              variant="success"
              size="sm"
              >Signature
            </b-button>
          </b-col>
          <b-col lg="3" md="6" sm="12" cols="12">
            <b-button variant="white" size="sm" @click="closeDecisionModal()">
              Fermer et sauvegarder
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import router from "../../router/index.js";
import Vuex from "vuex";

export default {
  props: ["value"],
  data() {
    return {
      optionsChausee: [
        "",
        "CH6C",
        "CH5C",
        "CH5D",
        "CH4B",
        "CH4C",
        "CH4D",
        "CH2A",
        "CH2B",
        "CH2C",
        "CH2D",
      ],
      optionsRefection: [
        {
          text: "Finisseur",
          value: "Finisseur",
        },
        {
          text: "Epaulement supérieur",
          value: "Epaulement supérieur",
        },
        {
          text: "pleine largeur chaussée",
          value: "pleine largeur chaussée",
        },
        {
          text: "pleine largeur trottoir",
          value: "pleine largeur trottoir",
        },
        {
          text: "piste cyclable",
          value: "piste cyclable",
        },
      ],
      refection_selected: [],
      optionsOuiNonSondage: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],

      optionsFoncage: [
        {
          text: "obligatoire",
          value: "obligatoire",
        },
        {
          text: "préconisé",
          value: "préconisé",
        },
        {
          text: "non",
          value: "non",
        },
      ],
      optionsAmenagements_selected: [],
      optionsAmenagements: [
        {
          text: "voirie moins de 3 ans",
          value: "voirie moins de 3 ans",
        },
        {
          text: "voirie en bon état",
          value: "voirie en bon état",
        },
        {
          text: "trottoir en bon état",
          value: "trottoir en bon état",
        },
        {
          text: "voir la mairie",
          value: "voir la mairie",
        },
      ],
      optionsOuiNonSignalH: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      optionsAccotement: ["", "TA1", "TA2", "TV2"],
      optionsTrottoir: [
        "",
        "TR1A",
        "TR1B",
        "TR1C",
        "TR1D",
        "TR2C",
        "TR2D",
        "TR2E",
      ],
      optionsOuiNonRejetTravaux: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      optionsAerien_selected: [],
      optionsOuiNonReseauTransport: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      optionsAerien: [
        { text: "Pose", value: "pose" },
        { text: "Dépose", value: "depose" },
        ,
      ],
      optionsDecision: [
        { text: "Favorable", value: true },
        { text: "Défavorable", value: false },
      ],
      annexe1: {
        file: null,
        typeDocument: {},
      },
      annexe2: {
        file: null,
        typeDocument: {},
      },
    };
  },

  mounted() {
    if (this.request.cerfa1402301.aerien !== null) {
      this.optionsAerien_selected = this.request.cerfa1402301.aerien.split(",");
    }
    if (this.request.cerfa1402301.decisionFacilitiesInfo !== null) {
      this.optionsAmenagements_selected = this.request.cerfa1402301.decisionFacilitiesInfo.split(",");
    } else {
      this.optionsAmenagements_selected = [];
    }
    if (this.request.cerfa1402301.decisionRefections !== null) {
      this.refection_selected = this.request.cerfa1402301.decisionRefections.split(",");
    } else {
      this.refection_selected = [];
    }
  },
  watch: {
    'request.cerfa1402301.decisionFacilitiesInfo'(newValue) {
      if (newValue !== null) {
        this.optionsAmenagements_selected = newValue.split(",");
      } else {
        this.optionsAmenagements_selected = [];
      }
    },
    'request.cerfa1402301.decisionRefections'(newValue) {
      if (newValue !== null) {
        this.refection_selected = newValue.split(",");
      } else {
        this.refection_selected = [];
      }
    }
  },

  methods: {
    addDestinataire() {
      let newDestinataire = {
        id: null,
        email: null,
      };
      this.request.mailArreteSignes.push(newDestinataire);
    },

    removeDestinataire(index) {
      this.request.mailArreteSignes.splice(index, 1);
    },
    calcDebitLs(obj) {
      this.$nextTick(() => {
        if (obj.decisionSurfacem2 != null) {
          let ha = obj.decisionSurfacem2 / 10000;
          let data = obj.decisionDebitLS * ha;
          obj.decisionResultCalc = data.toFixed(5);
        }
      });
    },
    ...Vuex.mapActions("Cerfa", ["setCerfa14023", "updateCerfa14023"]),
    ...Vuex.mapActions("Document", ["sendDocument"]),
    ...Vuex.mapActions("Dossiers", [
      "getDossier",
      "updateDossier",
      "setDossier",
      "startMerge",
      "extension",
      "updateReception",
      "getReception",
      "addReception",
      "sendToClicmap",
    ]),
    async decision() {
      //Condition pour création d'une annexe
      if (this.annexe1.file == null && this.annexe2.file == null) {
        this.request.doAnnexe = false;
      }
      if (this.annexe1.file != null) {
        if (this.annexe1.file.type != "application/pdf") {
          alert("L'annexe 1 n'est pas un type : \"application/pdf\"");
          return false;
        } else {
          this.annexe1.file.requestId = this.request.id;
          this.annexe1.file.typeDocumentId = 97;
          this.annexe1.file.stdUserId = this.userConnected.id;
          this.request.doAnnexe = true;
          await this.sendDocument(this.annexe1.file);
        }
      }
      if (this.annexe2.file != null) {
        if (this.annexe2.file.type != "application/pdf") {
          alert("L'annexe 2 n'est pas un type : \"application/pdf\"");
          return false;
        } else {
          this.annexe2.file.requestId = this.request.id;
          this.annexe2.file.typeDocumentId = 97;
          this.annexe2.file.stdUserId = this.userConnected.id;
          this.request.doAnnexe = true;
          await this.sendDocument(this.annexe2.file);
        }
      }

      if (this.request.cerfa1402301.decisionSinking == "obligatoire") {
        this.request.cerfa1402301.decisionRoadwayTrenchRecommended = "";
        this.request.cerfa1402301.decisionSidewalkTrenchRecommended = "";
        this.request.cerfa1402301.decisionShoulderVirginLandTrenchRecommended = "";
      }
      this.request.cerfa1402301.aerien = this.optionsAerien_selected.join();
      this.request.cerfa1402301.decisionFacilitiesInfo = this.optionsAmenagements_selected.join();
      this.request.cerfa1402301.decisionRefections = this.refection_selected.join();
      this.request.cerfa1402301.instructeurId = this.userConnected.id;

      //MAJ dossier
      this.request.state.id = 3;
      this.request.stateId = 3;
      this.request.sendToSign = true;
      this.request.instructeurId = this.userConnected.id;

      this.request.noMail = true;
      await this.updateDossier(this.request);
      this.vModel = false;

      this.sendToClicmap(this.request.id);
    },

    async doArrete() {
      if (this.request.cerfa1402301.decisionSinking == "obligatoire") {
        this.request.cerfa1402301.decisionRoadwayTrenchRecommended = "";
        this.request.cerfa1402301.decisionSidewalkTrenchRecommended = "";
        this.request.cerfa1402301.decisionShoulderVirginLandTrenchRecommended = "";
      }
      //this.request.cerfa1402301.isFavorable = null;
      this.request.cerfa1402301.aerien = this.optionsAerien_selected.join();
      this.request.cerfa1402301.decisionFacilitiesInfo = this.optionsAmenagements_selected.join();
      this.request.cerfa1402301.decisionRefections = this.refection_selected.join();
      this.request.cerfa1402301.instructeurId = this.userConnected.id;
      await this.updateCerfa14023(this.request.cerfa1402301);

      //ATTENTION FIX URGENCE pas de tableau pour OnlyOffice !
      this.request.stateId = 999;
      this.request.sendToSign = false;

      //Token qui peut servier pour sécuriser la route pour édition de l'arrêté
      // this.request.tokenUser = window.$cookies.get("token-sudthd");

      //noMail permet de mettre à jour la request sans envoyer de mail, quand la request conserve son stateId 3
      this.request.noMail = true;
      await this.updateDossier(this.request);
      // this.request.tokenUser = window.$cookies.get("token-sudthd");
      let dataToSend = {};

      Object.flatten = function(data) {
        var result = {};
        function recurse(cur, prop) {
          if (Object(cur) !== cur) {
            result[prop] = cur;
          } else if (Array.isArray(cur)) {
            for (var i = 0, l = cur.length; i < l; i++)
              recurse(cur[i], prop + "[" + i + "]");
            if (l == 0) result[prop] = null;
          } else {
            var isEmpty = true;
            for (var p in cur) {
              isEmpty = false;
              recurse(cur[p], prop ? prop + "_" + p : p);
            }
            if (isEmpty && prop) result[prop] = {};
          }
        }
        recurse(data, "");
        return result;
      };

      Object.toSlaveData = function(data) {
        var result = {};
        function recurse(cur, prop) {
          if (Object(cur) !== cur) {
            result[prop] = cur;
          } else if (Array.isArray(cur)) {
            let slaveData = {};
            slaveData[prop] = [];
            for (var i = 0, l = cur.length; i < l; i++) {
              slaveData[prop][i] = Object.toSlaveData(cur[i]);
            }
            result["slaveData"] = slaveData;
          } else {
            var isEmpty = true;
            for (var p in cur) {
              isEmpty = false;
              recurse(cur[p], prop ? prop + "_" + p : p);
            }
            if (isEmpty && prop) result[prop] = {};
          }
        }
        recurse(data, "");
        return result;
      };

      dataToSend = Object.flatten(this.request);
      dataToSend.slaveData = {};
      let adresses = [];
      this.request.adresses.forEach((element) => {
        adresses.push(Object.toSlaveData(element));
      });
      dataToSend.slaveData.adresses = adresses;

      //ATTENTION FIX URGENCE pas de tableau pour OnlyOffice !
      //Les données nécessaires sont récupérées dans le back

      delete dataToSend.adresses;
      delete dataToSend.petitioner_beneficiaryRequests;
      delete dataToSend.ticketOffices;
      delete dataToSend.mailArreteSignes;
      delete dataToSend.beneficiary_petitionerRequests;
      delete dataToSend.documents;
      delete dataToSend.individualAlignmentRequest_rues;
      await this.startMerge(dataToSend);
      await this.getDossier(this.request.id);
    },
    editArrete() {
      let docArreteid = null;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            docArreteid = element.id;
          }
        });
      }
      if (docArreteid !== null) {
        let url = window.urlapi + 'onlyoffice/' + docArreteid;

        fetch(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + window.$cookies.get("token-sudthd")
            }
          })
          .then(async (response) => {
            if (!response.ok) {
              const text = await response.text();
              throw new Error(`Erreur ${response.status} : ${text}`);
            }
            return response.text();
          })
          .then((html) => {
            const newWindow = window.open();
            if (newWindow) {
              newWindow.document.open();
              newWindow.document.write(html);
              newWindow.document.close();
            } else {
              Vue.prototype.$awn.alert("Impossible d'ouvrir une nouvelle fenêtre.");
            }
          })
          .catch((error) => {
            console.error("Erreur lors de l'ouverture du courrier :", error);
            Vue.prototype.$awn.alert("Erreur lors de l'ouverture du courrier : " + error.message, {
              position: "bottom-right",
              timeout: 5000,
            });
          });
      } else {
        alert("Aucun arrêté de généré pour cette demande");
      }
    },
    async removeCourrier() {
      let doc = false;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            doc = element;
          }
        });
      }
      await this.removeDocument(doc.id);
      await this.getDossier(this.request.id);
      return;
      // this.$emit("removeDocument", doc);
    },
    async closeDecisionModal() {
      this.annexe1 = {
        file: null,
        typeDocument: {},
      };
      this.annexe2 = {
        file: null,
        typeDocument: {},
      };
      this.arrete = {
        file: null,
        typeDocument: {},
      };

      if (this.request.cerfa1402301.decisionSinking == "obligatoire") {
        this.request.cerfa1402301.decisionRoadwayTrenchRecommended = "";
        this.request.cerfa1402301.decisionSidewalkTrenchRecommended = "";
        this.request.cerfa1402301.decisionShoulderVirginLandTrenchRecommended = "";
      }
      this.request.cerfa1402301.aerien = this.optionsAerien_selected.join();
      this.request.cerfa1402301.decisionFacilitiesInfo = this.optionsAmenagements_selected.join();
      this.request.cerfa1402301.decisionRefections = this.refection_selected.join();
      this.request.cerfa1402301.instructeurId = this.userConnected.id;
      await this.updateCerfa14023(this.request.cerfa1402301);
      this.request.sendToSign = false;
      //noMail permet de mettre à jour la request sans envoyer de mail, quand la request conserve son stateId 3
      this.request.noMail = true;
      await this.updateDossier(this.request);
      // this.refection_selected = [];
      this.vModel = false;
    },
    ...Vuex.mapActions("Document", ["removeDocument"]),
  },
  computed: {
    showBtnGen() {
      let disabled = true;
      if (
        this.request.cerfa1402301 &&
        this.request.cerfa1402301.isFavorable !== null
      ) {
        disabled = false;
      }
      return disabled;
    },
    showBtnArreteEdition() {
      //Si dans la liste des docs tu as un arrêté avec type 93 ? alors on récup sont ID pour construire urlOpenDoc
      let disabled = true;
      if (this.request.documents) {
        this.request.documents.forEach(function(element) {
          if (element.typeDocument.id == 93) {
            disabled = false;
          }
        });
      }
      return disabled;
    },
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    vModel: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      },
    },
    decisionRefectionValues: {
      get() {
        return this.refection_selected;
      },
      set(val) {
        this.refection_selected = val;
      },
    },
    ...Vuex.mapGetters("Dossiers", [
      "dossierSelected",
      "features",
      "managers",
      "reception",
      "urlOpenDoc",
    ]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
};
</script>
